import { Group } from "@mantine/core";
import { Dispatch } from "react";
import {
  CatalogueAction,
  CatalogueState,
} from "../../../hooks/admin/useSystemEmailsPage";
import { SystemEmailCategoryFilter } from "./SystemEmailCategoryFilter";
import { SystemEmailModeFilter } from "./SystemEmailModeFilter";
import { SystemEmailSearchFilter } from "./SystemEmailSearchFilter";

interface Props {
  state: CatalogueState;
  dispatch: Dispatch<CatalogueAction>;
}

export function SystemEmailCatalogueFilters({ state, dispatch }: Props) {
  return (
    <Group align="end" grow>
      <SystemEmailSearchFilter dispatch={dispatch} value={state.search} />
      <SystemEmailCategoryFilter dispatch={dispatch} value={state.category} />
      <SystemEmailModeFilter dispatch={dispatch} value={state.mode} />
    </Group>
  );
}
